import { SvgIcon } from "@material-ui/core";
import React from "react";

export const SadIcon: React.FC = (props) => {
	return (
		<SvgIcon {...props}>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
				<rect width="256" height="256" fill="none" />
				<circle
					cx="128"
					cy="128"
					r="96"
					fill="none"
					stroke="currentColor"
					stroke-miterlimit="10"
					stroke-width="16"
				/>
				<circle cx="92" cy="108" r="12" />
				<circle cx="164" cy="108" r="12" />
				<path
					d="M168,176c-8.3-14.35-22.23-24-40-24s-31.7,9.65-40,24"
					fill="none"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="16"
				/>
			</svg>
		</SvgIcon>
	);
};

export const HappyIcon: React.FC = (props) => {
	return (
		<SvgIcon {...props}>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
				<rect width="256" height="256" fill="none" />
				<circle
					cx="128"
					cy="128"
					r="96"
					fill="none"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="16"
				/>
				<circle cx="92" cy="108" r="12" />
				<circle cx="164" cy="108" r="12" />
				<path
					d="M168,152c-8.3,14.35-22.23,24-40,24s-31.7-9.65-40-24"
					fill="none"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="16"
				/>
			</svg>
		</SvgIcon>
	);
};

export const NeutralSmileIcon: React.FC = (props) => {
	return (
		<SvgIcon {...props}>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
				<rect width="256" height="256" fill="none" />
				<circle
					cx="128"
					cy="128"
					r="96"
					fill="none"
					stroke="currentColor"
					stroke-miterlimit="10"
					stroke-width="16"
				/>
				<line
					x1="88"
					y1="160"
					x2="168"
					y2="160"
					fill="none"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="16"
				/>
				<circle cx="92" cy="108" r="12" />
				<circle cx="164" cy="108" r="12" />
			</svg>
		</SvgIcon>
	);
};
